import React from "react";
import { toElementProps } from "../../Element";
import { BurgerMenuStyles } from "./BurgerMenu.jsx";

export function BlockMenuStyles(params = {}) {
    const { palette, MobileBreakpoint } = params;

    return {
        "& .block-menu": {
            position: "absolute",
            top: 0,
            zIndex: 128,

            width: "100%",
            height: "80px",
            padding: "0",
            backgroundColor: "transparent !important",

            transition: "all 250ms ease",

            [MobileBreakpoint]: {
                display: "flex !important",
                justifyContent: "space-between",
            },

            "& .block-menu-content": {
                display: "grid",
                width: "100%",
                maxWidth: "100%",
                height: "100%",
                margin: "auto",
                gridTemplateColumns: "max-content 1fr max-content !important",
                alignItems: "center",

                transition: "all 250ms ease",

                [MobileBreakpoint]: {
                    gridTemplateColumns: "1fr max-content !important",
                },
            },

            "& .logotype": {
                padding: "0 16px",
            },

            "& .filter-brightness": {
                filter: `brightness(0) invert(${palette.primary.initialTextIsLight ? "1" : "0"})`,
                transition: "all 250ms ease",
            },

            "& .link": {
                color: palette.primary.initialText + " !important",
            },

            "& .button": {
                borderColor: palette.primary.initialText + " !important",
                backgroundColor: "transparent !important",
                fontSize: "18px !important",
                color: palette.primary.initialText + " !important",
            },

            "& .logotype, .menu-links, .menu-buttons": {
                padding: "0 16px",
                fontSize: "20px",

                "& .menu-link, .menu-button": {
                    fontSize: "inherit",
                },
            },

            // Styles
            "&.style-with-buttons-1 .block-menu-content": {
                gridTemplateColumns: "200px 1fr max-content !important",

                "& .menu-links": {
                    justifySelf: "flex-end",
                },
            },

            "&.style-with-buttons-2 .block-menu-content": {
                gridTemplateColumns: "200px 1fr max-content !important",

                "& .menu-links": {
                    justifySelf: "center",
                },
            },

            // NotTop
            "&.not-top": {
                position: "fixed",

                height: "60px",
                backgroundColor: "#ffffff !important",
                color: "#000000 !important",

                "& .filter-brightness": {
                    filter: `brightness(0) invert(0)`,
                    transition: "all 250ms ease",
                },

                "& .link": {
                    color: "#000000 !important",
                },

                "& .button": {
                    borderColor: "transparent !important",
                    backgroundColor: palette.primary.initial + " !important",
                    fontSize: "18px !important",
                    color: palette.primary.initialText + " !important",

                    "&:hover": {
                        backgroundColor: palette.primary.lighter + " !important",
                        color: palette.primary.initialText + " !important",
                    },
                },

                [MobileBreakpoint]: {
                    "& .button": {
                        borderColor: palette.primary.initialText + " !important",
                        backgroundColor: "transparent !important",
                        fontSize: "18px !important",
                        color: palette.primary.initialText + " !important",
                    },

                    "& .link": {
                        color: palette.primary.initialText + " !important",
                    },

                    "& .burger-menu-btn span": {
                        filter: "brightness(0) invert(0)",
                    },
                },
            },

            [MobileBreakpoint]: {
                "& .button": {
                    borderColor: palette.primary.initialText + " !important",
                    backgroundColor: "transparent !important",
                    fontSize: "18px !important",
                    color: palette.primary.initialText + " !important",
                },
                "& .link": {
                    color: palette.primary.initialText + " !important",
                },
            },
        },

        ...BurgerMenuStyles(params),
    };
}

export default function BlockMenu(props) {
    const refBlockMenu = React.useRef(null);

    React.useEffect(() => {
        if (props.mobile) {
            return;
        }

        window.addEventListener("scroll", OnWindowScroll);
        window.dispatchEvent(new Event("scroll"));

        return () => {
            window.removeEventListener("scroll", OnWindowScroll);
        };
    });

    function OnWindowScroll() {
        if (!refBlockMenu.current) {
            return;
        }

        const domMenu = refBlockMenu.current;
        const domParent = domMenu.parentElement;

        const bbParent = domParent.getBoundingClientRect();
        domMenu.classList[bbParent.top < 0 ? "add" : "remove"]("not-top");
    }

    const CNBlockMenu = ["block-menu", "sticky"];
    const elProps = toElementProps(props, { className: CNBlockMenu });
    return (
        <div ref={refBlockMenu} {...elProps}>
            <div className="block-menu-content w1200px">{props.children}</div>
        </div>
    );
}
